import { Adapter } from './types';
import { AnalyticsEvent } from '../events';
import { recordStep } from '../behaviour/snapshot';

let startedAt = 0;

export const startVisitSignalsClock = (at: number): void => {
  startedAt = at;
};

export const _resetVisitSignalsClockForTests = (): void => {
  startedAt = 0;
};

/**
 * Records the shape of the route through the page.
 *
 * It listens to the same stream the Sentry adapter does, so the vocabulary is the page's existing
 * one and there is no second dictionary to keep in sync. Sending nothing anywhere itself, it cannot
 * fail in a way the client would see; the tracker isolates each adapter anyway.
 */
export const visitSignalsAdapter: Adapter = {
  name: 'visit-signals',
  send(event: AnalyticsEvent): void {
    recordStep(event.name, Math.max(0, Date.now() - startedAt));
  },
};
